module.exports = __webpack_public_path__ + "static/media/logo-por.75b01dba.png";